// extracted by mini-css-extract-plugin
export var cdDarkLoader = "loader-overlay-module--cd-dark-loader--c6ebb";
export var cdLoaderOverlay = "loader-overlay-module--cd-loader-overlay--b0e49";
export var cdMiniLoaderOverlay = "loader-overlay-module--cd-mini-loader-overlay--27e66";
export var loader1 = "loader-overlay-module--loader-1--58722";
export var loader11 = "loader-overlay-module--loader-1-1--0070b";
export var loader12 = "loader-overlay-module--loader-1-2--0d479";
export var loader13 = "loader-overlay-module--loader-1-3--47349";
export var multiRipple = "loader-overlay-module--multi-ripple--23ae3";
export var ripple = "loader-overlay-module--ripple--a2ec8";